import { DropdownMenuItemId } from '@api-ui-app/src/app/mockup-studio/types/mockup-studio-scenes';
import { CardDropdownMenuItem } from '@gelato-api-ui/ui-kit/src/lib/cards/types/cards';
import { MockupCategory, MockupSize } from '../types/mockup-studio-mockups';

// TODO add translation / move it to Sanity ?
export const categories: MockupCategory[] = [
  { name: 'Standard', id: 'standard' },
  { name: 'E-commerce', id: 'e-com' },
];

// TODO add translation / move it to Sanity ?
export const sizes: MockupSize[] = [
  {
    name: 'Square mockup',
    width: 3000,
    height: 3000,
    categoryId: categories[0].id,
  },
  {
    name: 'Rectangular mockup',
    width: 3000,
    height: 2000,
    categoryId: categories[0].id,
  },
  {
    name: 'Shopify product',
    width: 2048,
    height: 2048,
    categoryId: categories[1].id,
  },
  {
    name: 'Etsy listing',
    width: 2666,
    height: 2000,
    categoryId: categories[1].id,
  },
];

export const CARD_DROPDOWN_MENU_ITEMS: CardDropdownMenuItem[] = [
  { id: DropdownMenuItemId.edit, textKey: 'txt_edit', icon: '/assets/store-product-icons/edit.svg' },
  { id: DropdownMenuItemId.rename, textKey: 'txt_rename', icon: '/assets/icons/rename.svg' },
  { id: DropdownMenuItemId.duplicate, textKey: 'txt_duplicate', icon: '/assets/icons/copy.svg' },
  { id: DropdownMenuItemId.delete, textKey: 'txt_delete', icon: '/assets/icons/remove-red.svg' },
];

// These combinations are used to generate previews for mockups and check its quality.
// It is hardcoded by purpose since we do not have any API to get it
// color - apparel color
// bg - background color
export const PREVIEW_TEMPLATES_COLORS_COMBINATIONS = [
  {
    color: 'ff0000', // red
    bg: 'ffffff', // white
  },
  {
    color: 'ffffff', // white
    bg: 'ff0000', // red
  },
  {
    color: 'ffffff', // white
    bg: 'ffffff', // white
  },
];

// It is used by to test that print areas are placed correctly on the mockup.
// It is hardcoded by purpose since we do not have any API to get it
export const IMAGE_URL =
  'https://gelato-api-test.s3.eu-west-1.amazonaws.com/preflight/assets/tests/mountain-1024x1024.jpg';

export const IS_ALLOWED_TO_PUBLISH_MOCKUPS_ROLE = 'urn:preflight:scopes:scene-publish:rw';
